/**
 * Splits a Data URL (from FileReader.readAsDataURL) into its content type and raw base64 payload.
 * Robust to extra header parameters (e.g. `data:text/csv;charset=utf-8;base64,...`).
 */
export const parseDataUrl = (dataUrl, fallbackType) => {
  const commaIndex = dataUrl.indexOf(',');
  const header = commaIndex !== -1 ? dataUrl.slice(0, commaIndex) : '';
  const rawBase64 = commaIndex !== -1 ? dataUrl.slice(commaIndex + 1) : dataUrl;
  const contentType = fallbackType || header.match(/^data:([^;]+)/)?.[1];
  return { rawBase64, contentType };
};
